export const shareGlobalName = 'EMP_SHARE_RUNTIME'
